/*
==============================
Lightbox
==============================
*/


var autofitIframe = (typeof autofitIframe !== "undefined") ? autofitIframe : function(a) {
    if (a.height === '95%') {
        if (!window.opera && document.all && document.getElementById) {
            a.style.height = a.contentWindow.document.body.scrollHeight;
        } else {
            if (document.getElementById) {
                a.style.height = (35 + a.contentDocument.body.scrollHeight) + 'px';
            }
        }
    }
},
getQuery = (typeof getQuery !== "undefined") ? getQuery : function(myIFrameTieneParemetros) {
    var url = location.href,
        params = url.indexOf('?'),
        primerCaracterResult = (myIFrameTieneParemetros > -1) ? '&' : '?',
        result = '';
    if (params !== -1) {
        var qs = url.substring(params + 1).split('&');
        for (var i = 0, result = primerCaracterResult; i < qs.length; i++) {
            qs[i] = qs[i].split('=');
            if (i > 0) {
                result += "&";
            }
            result += ([qs[i][0]] + "=" + decodeURIComponent(qs[i][1]));
        }
    }
    return result;
},
setIframeQueryStringParametersByClass = (typeof setIframeQueryStringParametersByClass !== "undefined") ? setIframeQueryStringParametersByClass : function(iframeClass) {
    var myFrame = $('.' + iframeClass);
    $('.' + iframeClass).each(function() {
        setIframeQueryStringParameters(this);
    });
},
setIframeQueryStringParameters = (typeof setIframeQueryStringParameters !== "undefined") ? setIframeQueryStringParameters : function(myFrame) {
    var myFrameSrc = $(myFrame).attr('rel'),
        myIFrameTieneParemetros = myFrameSrc.indexOf('?'),
        url = myFrameSrc + getQuery(myIFrameTieneParemetros);
    $(myFrame).attr('src', url);
},
listenerloadLBEnContainer = (typeof listenerloadLBEnContainer !== "undefined") ? listenerloadLBEnContainer : function(containerHeight, containerWidth) {
    try {
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
        eventer(messageEvent, function(e) {
            if (e.origin == "https://www.bancomer.com" || e.origin == "http://www.bancomer.com") { ///Se evalua origen, por seguridad puede esperar respuesta desde http o https bancomer.com, los datos enviados estan en formato JSON
                if (e.data.action == "wizard") { ///esta accion abre el lightBox con la pantalla de Ayuda Interactiva
                    loadLBEnContainer(e.data.url, containerHeight, containerWidth, "", ""); ///funccion define URL y tamaño de la ventana
                } else if (e.data.action == "cierra") { ///esta accion cierra el lightBox y cambia la fuente del iframe de acceso
                    $('#IframeresetId').attr('src', e.data.url); ///cambiamos la fuente del iframe de acceso
                    $("#destino0" + " *").remove(); ///cerramos lightBox
                }
            }
        }, false);
    } catch (err) {
        console.log(err); ///en caso de error mandamos el mensaje la consola de errores de javascript
    }
},
// Para mantener las alturas de los iframes
SetIframeHeight = (typeof SetIframeHeight !== "undefined") ? SetIframeHeight : function(an) {
    var isOldIE = (navigator.userAgent.indexOf("MSIE") !== -1); // Detect IE10 and below
    var isIE8 = (navigator.userAgent.indexOf("MSIE 8") !== -1);
    var isButonCheckPoints = "IframeresetId" == an;
    var applyResize = !((isIE8) && (isButonCheckPoints));

    if (applyResize) {
        if (isOldIE) {
            $('#' + an).iFrameResize({
                heightCalculationMethod: 'max',
                interval: 32,
                // minHeight: 210
            });
        } else {
            $('#' + an).iFrameResize({
                heightCalculationMethod: 'max',
                interval: 0
            });
        }
    }
    else if (isIE8) {
        $('#' + an).iFrameResize({
            heightCalculationMethod: 'max',
            interval: 32
        });
    }
},
SetIframeHeightByClass = (typeof SetIframeHeightByClass !== "undefined") ? SetIframeHeightByClass : function(an) {
    var isOldIE = (navigator.userAgent.indexOf("MSIE") !== -1); // Detect IE10 and below
    if (isOldIE) {
        $('.' + an).iFrameResize({
            heightCalculationMethod: 'max',
            interval: 32,
            minHeight: 600
        });
    } else {
        $('.' + an).iFrameResize({
            heightCalculationMethod: 'max',
            interval: 0
        });
    }
};

if (typeof cargaLB !== "undefined") {
    $(function() {
        cargaLB();

        if(typeof siteBancomer === 'undefined'){
            listenerloadLBEnContainer(700, 450);
        }

        setIframeQueryStringParametersByClass('queryIframeParam');
        SetIframeHeightByClass('queryIframe');
    });
}
